<template>
  <a-layout class="vb__layout">
    <a-layout-content>
      <!--<vb-sidebar />-->
      <!--<vb-support-chat />-->
      <div
        :class="{
          [$style.container]: true,
          vb__layout__squaredBorders: settings.isSquaredBorders,
          vb__layout__cardsShadow: settings.isCardShadow,
          vb__layout__borderless: settings.isBorderless,
          [$style.white]: settings.authPagesColor === 'white',
          [$style.gray]: settings.authPagesColor === 'gray',
        }"
        :style="{
          backgroundImage:
            settings.authPagesColor === 'image'
              ? `url(resources/images/content/photos/8.jpeg)`
              : 'none',
        }"
      >
        <div
          :class="{
            [$style.topbar]: true,
            [$style.topbarGray]: settings.isGrayTopbar,
          }"
        >
          <div :class="$style.logoContainer">
            <div :class="$style.logo">
              <img src="/logo.png" alt="" height="24" width="24" style="margin-right: 5px;" />

              <div :class="$style.name">
                {{ settings.logo }}
              </div>
            </div>
          </div>
          <div v-if="false" class="d-none d-sm-block">
            <span class="mr-2">Don't have an account?</span>
            <router-link to="/auth/register" class="font-size-16 vb__utils__link">
              Sign up
            </router-link>
          </div>
        </div>
        <div class="mb-5">
          <router-view v-slot="{ Component }">
            <transition :name="settings.routerAnimation" mode="out-in">
              <component :is="Component" />
            </transition>
          </router-view>
        </div>
        <div class="mt-auto pb-5 pt-5">
          <ul
            v-if="false"
            class="list-unstyled d-flex mb-0 flex-wrap justify-content-center"
            :class="[$style.footerNav]"
          >
            <li>
              <a href="javascript: void(0);">Terms of Use</a>
            </li>
            <li class="active list-inline-item">
              <a href="javascript: void(0);">Compliance</a>
            </li>
            <li>
              <a href="javascript: void(0);">Support</a>
            </li>
            <li>
              <a href="javascript: void(0);">Contacts</a>
            </li>
            <li>
              <a href="javascript: void(0);">About</a>
            </li>
            <li>
              <a href="javascript: void(0);">Advertising</a>
            </li>
          </ul>
          <div class="text-center">
            <a href="https://www.cm-pombal.pt/" target="_blank" rel="noopener noreferrer">
              Município de pombal
            </a>
            |
            {{ new Date().getFullYear() }}
          </div>
        </div>
      </div>
    </a-layout-content>
  </a-layout>
</template>

<script>
import { mapState } from 'vuex'
import VbSidebar from '@/@vb/components/Sidebar'
import VbSupportChat from '@/@vb/components/SupportChat'

export default {
  name: 'AuthLayout',
  components: { VbSidebar, VbSupportChat },
  computed: mapState(['settings']),
}
</script>

<style lang="scss" module>
@import './style.module.scss';
</style>
